module.exports = __webpack_public_path__ + "img/IC_plan_biometrico_secondary_white.b629116f.svg";